import { render, staticRenderFns } from "./LeaveSheet.vue?vue&type=template&id=2c88b8fb&scoped=true"
import script from "./LeaveSheet.vue?vue&type=script&lang=js"
export * from "./LeaveSheet.vue?vue&type=script&lang=js"
import style0 from "./LeaveSheet.vue?vue&type=style&index=0&id=2c88b8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88b8fb",
  null
  
)

export default component.exports